import { useEffect } from 'react';

/**
 * Zavola handler pri stisku Escape. Aktivni jen kdyz je `active` true - typicky kdyz je modal otevreny.
 */
export function useEscapeKey(active: boolean, handler: () => void) {
  useEffect(() => {
    if (!active) return;

    const listener = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handler();
      }
    };

    document.addEventListener('keydown', listener);
    return () => document.removeEventListener('keydown', listener);
  }, [active, handler]);
}
